
import React from 'react'

import './InputDate.scss'

interface Props {
  value: string
  onChange?: (value: string) => void
  placeholder?: string
  className?: string
  disabled?: boolean
  invalid?: boolean
}

const InputDate = (props: Props) => {

  const {
    value,
    onChange,
    className = '',
    invalid,
    ...rest
  } = props

  return (
    <input
      type='date'
      className={`input-date ${className} ${invalid ? 'invalid' : ''}`}
      value={value}
      onChange={(e: any) => {

        if (onChange) onChange(e.target.value)
      }}
      {...rest}
    />
  )
}

export default InputDate
